import Em from 'ember';

export default Em.Component.extend({
  actions: {
    clickedInsert() {
      this.get('inserterApi.insertCharacter')('a');
    },
  },
});
